import { useNavigate } from "react-router";
import { httpStatusCodes } from "~/constants/httpStatusCodes";
import type { ErrorStatus } from "~/types/error";

type ErrorPageProps = {
  statusCode?: number;
};

export const ErrorPage = ({ statusCode = 404 }: ErrorPageProps) => {
  const navigate = useNavigate();
  const status: ErrorStatus = httpStatusCodes.get(statusCode) ?? {
    code: 500,
    message: "エラーが発生しました",
    description: "予期しないエラーが発生しました。後ほどアクセスをお願いします。",
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-8">
        <div className="flex flex-col items-center gap-4">
          <p className="text-[96px] font-semibold leading-24 text-gray-300">{status.code}</p>
          <p className="text-2xl font-bold leading-8 text-indigo-900">{status.message}</p>
          <p className="text-center text-base leading-6 text-gray-500">{status.description}</p>
        </div>
        <button
          type="button"
          onClick={handleGoBack}
          className="rounded-lg border-2 border-indigo-900 px-5 py-3 text-sm font-semibold text-indigo-900 hover:bg-indigo-50"
        >
          前のページへ戻る
        </button>
      </div>
    </div>
  );
};
